import { sanitizeFileName } from '@maximizer/shared/util';
import { CardDocument, decodeDocument } from '@maximizer/actions/domain';

export function downloadDocument(document: CardDocument): void {
  const url = URL.createObjectURL(decodeDocument(document));
  const link = globalThis.document.createElement('a');

  link.href = url;
  link.download = sanitizeFileName(document.name);

  globalThis.document.body.appendChild(link);
  link.click();
  link.remove();

  setTimeout(() => URL.revokeObjectURL(url));
}
